import { render, staticRenderFns } from "./EmployeeAdminOrder.vue?vue&type=template&id=73770a1c&scoped=true&"
import script from "./EmployeeAdminOrder.vue?vue&type=script&lang=js&"
export * from "./EmployeeAdminOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73770a1c",
  null
  
)

export default component.exports